<div class="h-full flex flex-col">
  <div class="w-[1010px] flex flex-row items-center justify-between py-[30px]">
    <div class="v4-filter-list">
      <div class="v4-filter-item">
        <div class="v4-filter-style">
          <nz-select
            [nzDropdownMatchSelectWidth]="false"
            [(ngModel)]="channelHouse"
            (ngModelChange)="onChannelHouseChange($event)"
            [nzCustomTemplate]="defaultTemplate">
            <nz-option *ngFor="let opt of listOfChannelHouse" nzCustomContent [nzValue]="opt">
              <img class="w-[16px]" [src]="(opt.thirdparty_type | thirdparty)?.icon_color" alt="" />
              {{ opt.thirdparty_house_title }}
              <span *ngIf="opt.c_readonly"> {{ opt.c_rate_plan_desc }}</span>
            </nz-option>
            <!-- <nz-option
              *ngFor="let opt of listOfUniqueKeys"
              [nzLabel]="('word.channel_' + opt.thirdparty_type | translate) + (opt.number > 0 ? opt.number : '')"
              [nzValue]="opt.unique_key"
            ></nz-option> -->

            <ng-template #defaultTemplate let-selected>
              <img class="w-[16px]" [src]="(selected.nzValue.thirdparty_type | thirdparty)?.icon_color" alt="" />
              {{ selected.nzValue?.c_title }}
            </ng-template>
          </nz-select>
        </div>
      </div>
      <div class="v4-filter-item">
        <nz-select [(ngModel)]="currentMonth" (ngModelChange)="onMonthChange($event)">
          <nz-option *ngFor="let month of listOfMonthOption" [nzLabel]="month" [nzValue]="month"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="v4-filter-list">
      <div class="v4-filter-item">
        <button nz-button nzType="default" (click)="synchroniseCalendar()">
          <i nz-icon nzType="sync" nzTheme="outline"></i>
          {{ "calendar.sync_calendar" | translate }}
          <!-- 读取渠道日历 -->
        </button>
      </div>
    </div>
  </div>

  <div class="flex flex-row flex-wrap flex-1 overflow-y-auto" #scrollContainer>
    <div
      class="mr-[30px] mb-[30px] border border-solid border-[#e2e5e9] rounded-[12px] overflow-hidden calendar-item"
      *ngFor="let month of listOfMonthOption">
      <div class="calendar-skeleton" [attr.data-month]="month">
        <div
          [ngClass]="{
            'w-[490px] h-[440px] p-[30px]': !inviewedMonth.has(month),
            'w-0 h-0': inviewedMonth.has(month)
          }">
          <nz-skeleton class="mx-auto" [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
        </div>

        <ng-container *ngIf="inviewedMonth.has(month)">
          <div class="leading-[42px] text-center text-[16px] text-[#272b30] border-b border-solid border-[#e2e5e9]">
            {{ month | dateformat: ["YM"] }}
          </div>
          <host-month-price-calendar-v2
            [currentDate]="month"
            [currency]="currentCurrency"
            [uniqueKey]="uniqueKey"
            [thirdparty]="thirdpartyType"
            [relatedHouse]="houseEntity"
            [calendarMap]="calendarMap"
            [listOfSelectedDates]="listOfSelectedDates"
            [selectStatus]="selectStatus"
            (onSelectCell)="onSelectCell($event)"
            (onClickChangeAvailable)="onClickChangeAvailable($event)"
            (onClickChangeTab)="onClickChangeTab($event)"></host-month-price-calendar-v2>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- <host-operate-sidebar *ngIf="selectStatus?.status === 'done'" [type]="'channel'"></host-operate-sidebar> -->
